import { Link, useLocation, useNavigate } from 'react-router-dom';

function AdminTabs({ activeTab, onTabChange }) {
  const location = useLocation();
  const navigate = useNavigate();

  // If activeTab and onTabChange are provided, use internal state (SettingsPage)
  // Otherwise, navigate to /admin with state
  const handleTabClick = (tabName) => {
    if (activeTab !== undefined && onTabChange) {
      onTabChange(tabName);
    } else {
      navigate('/admin', { state: { activeTab: tabName } });
    }
  };

  // Determine if a tab is active
  const isTabActive = (tabName) => {
    if (activeTab !== undefined) {
      return activeTab === tabName;
    }
    return location.pathname === '/admin' && location.state?.activeTab === tabName;
  };

  return (
    <div className="flex gap-2 border-b border-gray-200 mb-6">
      <Link
        to="/admin/marketing"
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          location.pathname === '/admin/marketing'
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Marketing
      </Link>
      <Link
        to="/admin/gallery"
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          location.pathname === '/admin/gallery'
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Admin Gallery
      </Link>
      <Link
        to="/admin/bundles"
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          location.pathname === '/admin/bundles'
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Bundles
      </Link>
      <button
        onClick={() => handleTabClick('email')}
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          isTabActive('email')
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Test Email
      </button>
      <button
        onClick={() => handleTabClick('outreach-email')}
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          isTabActive('outreach-email')
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Outreach Email
      </button>
      <button
        onClick={() => handleTabClick('configuration')}
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          isTabActive('configuration')
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Configuration
      </button>
      <button
        onClick={() => handleTabClick('utilities')}
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          isTabActive('utilities')
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Utilities
      </button>
      <button
        onClick={() => handleTabClick('users')}
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          isTabActive('users')
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Users
      </button>
      <Link
        to="/admin/redirects"
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          location.pathname === '/admin/redirects'
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Redirects
      </Link>
      <button
        onClick={() => handleTabClick('notes-editor')}
        className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
          isTabActive('notes-editor')
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-600 hover:text-gray-900'
        }`}
      >
        Notes
      </button>
    </div>
  );
}

export default AdminTabs;
